import { Get, Set } from "../../../../../Request";
export const FormSubmit = async data => {
  await Get({
    url: "/wallet/sharge",
    data: data,
    stat: true,
  }).then(data => {
    if (data && data.data && data.data.url) {
      window.location.replace(data.data && data.data.url);
    }
  });
};

export const GetData = async (limit = 15, page = null) => {
  return await Get({
    url: "/wallet/show",
    data: {
      limit: limit,
    },
    page,
    mess: true,
  }).then(data => {
    return data;
  });
};
